export default "__VITE_ASSET__614b51fd__"